import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useModal, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_REGN_CD_SRCH,
    SG_REGN_CD_LIST,
} from "@/tra/tancis/ptli/comnmdle/regncd/services/PtliRegnCdService";

/*
 * Region Code Management List
 * !== 지역 코드 관리 목록 ==!
 */
export const PTLI0415001Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "cntyCd" }, { area: "comnCd", comnCd: "COM0033" }],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0003"],
    });

    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        regnCdSrch: useForm({
            defaultSchema: SF_REGN_CD_SRCH,
            defaultValues: { ...pgeStore?.form },
        }),
    };

    const grid = {
        regnCdList: useGrid({
            defaultSchema: SG_REGN_CD_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of region codes. !== 지역코드 목록을 조회한다.==!
        getRegnCdList: useFetch({
            api: (page = grid.regnCdList.page) =>
                APIS.getRegnCdList(form.regnCdSrch.getValues(), page, grid.regnCdList.size),
            enabled: comnUtils.isEmpty(form.regnCdSrch.errors),
            key: [grid.regnCdList.page, grid.regnCdList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.regnCdSrch.getValues(),
                    page: grid.regnCdList.page,
                    size: grid.regnCdList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {
            regnCd: (props: any) => {
                const { rowValues, value } = props;
                return (
                    <Link to={`${URLS.ptli0415003s}/${rowValues.regnCd}-${rowValues.cntyCd}-${rowValues.regnTpCd}`}>
                        {value}
                    </Link>
                );
            },
        },
    };

    const handler = {
        getRegnCdList: () => {
            grid.regnCdList.setPage(0);
            fetch.getRegnCdList.fetch(0);
        },
    };

    useEffect(() => {
        handler.getRegnCdList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.cntyCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.regnCdSrch.schema.regnCd} />
                            <Group.Control {...form.regnCdSrch.schema.regnNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.regnCdSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getRegnCdList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.regnCdList.grid} data={fetch.getRegnCdList.data?.regnCdList} render={render} />
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout.Left>
                <Button
                    role={"new"}
                    onClick={() => {
                        navigate(`${URLS.ptli0415002s}?menuId=${menuId}`);
                    }}
                />
            </Layout.Left>
        </Page>
    );
};
